import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { navigate, openDialog, setSaveState } from '../../actions';
import { newUsuarioDB, updateDetallesUsuarioDB } from '../../actions/perfiles_usuario_actions';

const styles = theme => ({
    buttonsBottom: {
        margin: '20px 15px 30px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});


class UsuarioActionButtons extends Component {

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, 'save_usuario_detalles_error', false, 'sm');

    };


    checkFields = usuario => {

        if (usuario.codigoUsuario === '') {
            this.messageDialog('Por favor, rellene el campo Código de usuario');
            return false;
        }
        else if (usuario.password === '') {
            this.messageDialog('Por favor rellene el campo Password');
            return false;
        }
        else if (usuario.nombre === '') {
            this.messageDialog('Pro favor rellene el campo Nombre');
            return false;
        }

        return true;

    };

    updateHandler = () => {

        const centros = this.props.usuarioCentros.usuarioCentros.map(uc => {
            if (typeof uc.id !== 'number') return { ...uc, id: 0 };
            else return uc;
        })

        const usuario = {
            id: this.props.usuarioDetalles.id,
            codigoUsuario: this.props.usuarioDetalles.codigoUsuario,
            password: this.props.usuarioDetalles.password,
            nombre: this.props.usuarioDetalles.nombre,
            centroId: this.props.usuarioDetalles.centroId,
            activo: this.props.usuarioDetalles.activo,
            usuarioCentro: centros
        };

        if (this.checkFields(usuario)) {

            this.props.setSaveState(false);

            if (this.props.id === -1) this.props.newUsuarioDB(usuario, () => this.props.navigate('mae_auxiliares_perfiles_usuario'))

            else this.props.updateDetallesUsuarioDB(usuario, this.props.id, () => this.props.navigate('mae_auxiliares_perfiles_usuario'));
        };
    };

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.backHandler}>Atrás</Button>
                <Button
                    disabled={this.props.isLoading || this.props.usuarioCentros.isLoading}
                    className={classes.buttonsBottom}
                    variant="contained"
                    color="primary"
                    onClick={() => this.updateHandler()}>
                    Guardar
                </Button>
            </div>
        );
    };

};

UsuarioActionButtons.propTypes = {
    //state
    id: PropTypes.number.isRequired,
    usuarioDetalles: PropTypes.object.isRequired,

    //dispatch
    updateDetallesUsuarioDB: PropTypes.func.isRequired,
    newUsuarioDB: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        usuarioDetalles: state.usuarioDetalles.usuarioDetalles,
        usuarioCentros: state.usuarioCentros,
        isLoading: state.usuarioDetalles.isLoading
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        newUsuarioDB,
        updateDetallesUsuarioDB,
        navigate,
        openDialog,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(UsuarioActionButtons)));